import React from 'react'

import __t from '../../lib/traduzioni';
import { Menu } from '@mui/material';

import useBSSLogger from '../../hooks/useBSSLogger';
import { useWindowScroll } from 'react-use';
const {logger} = useBSSLogger();

const rightMenuAlignment = {
    anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
    transformOrigin: { horizontal: 'right', vertical: 'top' },  
}

const leftMenuAlignment = {
    anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
    transformOrigin: { horizontal: 'left', vertical: 'top' },  
}

const BSSMenu = ({MenuProps, children, rightAlignment = true}) => {

    const {x, y} = useWindowScroll();
    
    return (
        <>
            <Menu 
                disablePortal={true}
                disableScrollLock={true}
                {...(rightAlignment ? rightMenuAlignment: leftMenuAlignment)}
                {...MenuProps}                
            >
                {children}
            </Menu>
        </>
    )
}

export default BSSMenu;
export {rightMenuAlignment, leftMenuAlignment}